import React from 'react';
import { Checkbox as TailwindCheckbox, Field, Label } from '@headlessui/react';

type Props = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export default function Checkbox(props: Props) {
    const { checked, onChange, label } = props;

    return (
        <Field className="flex items-center gap-2">
            <TailwindCheckbox
                checked={checked}
                onChange={onChange}
                className="group block size-5 min-h-5 min-w-5 rounded border bg-white transition data-[checked]:bg-blue-500"
            >
                <svg
                    className="stroke-white opacity-0 transition group-data-[checked]:opacity-100"
                    viewBox="0 0 14 14"
                    fill="none"
                >
                    <path d="M3 8L6 11L11 3.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </TailwindCheckbox>
            <Label className={"text-textColor"} dangerouslySetInnerHTML={{ __html: label }}/>
        </Field>
    );
}